import styled from 'styled-components';
import { StyledSecondaryLgBtn } from '../styles';

export const StyledInfoContainer = styled.div`
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${props => props.theme.mediaSm}) {
    min-height: 90%;
  }

  img {
    display: inline-block;
    margin-bottom: 0;

    @media (min-width: ${props => props.theme.mediaXs}) {
      display: block;
      margin-bottom: 2rem;
    }
  }

  h3 {
    display: inline-block;
    margin-top: 1rem;
    @media (min-width: ${props => props.theme.mediaXs}) {
      display: block;
      margin-top: 0;
    }
  }
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  li::before {
    content: '-';
    margin-right: 0.3rem;
  }
`;

export const StyledInfoLink = styled(StyledSecondaryLgBtn)`
  font-size: 1.1rem;
`;

export const StyledImageContainer = styled.div`
  @media (min-width: ${props => props.theme.mediaSm}) {
    height: 7rem;
  }
`;
